// clarity.ts
declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
  }
}

export const trackClarityEvent = (
  eventName: string,
  data?: Record<string, any>
) => {
  try {
    if (window.clarity) {
      console.log('data', data, eventName)
      window.clarity("event", eventName, data || {});
    } else {
      console.warn("Clarity not initialized yet:", eventName);
    }
  } catch (error) {
    console.error("Clarity event error:", error);
  }
};
